import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-helper-functions',
  templateUrl: './helper-functions.component.html',
  styleUrls: ['./helper-functions.component.css']
})

export class HelperFunctionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}

export function getBaseLocation() {
  let paths: string[] = location.pathname.split('/').splice(1, 1);
  let basePath: string = (paths && paths[0]) || ''; // Default: ''
  return '/' + basePath;
}

